module.exports = __webpack_public_path__ + "img/CSAT2.6ff04db3.svg";